import { useQuery } from '@tanstack/react-query';
import { UserApiClient } from 'api/user';
import { PaginationModel, UserModel } from 'models';
import { JSONObject } from 'models/Api/types';

export function useUsers(params: JSONObject = {}) {
  return useQuery<PaginationModel<UserModel>>({
    queryKey: ['users', params],
    queryFn: () => UserApiClient.getUsers(params)
  });
}

export function useAdminUsers() {
  return useQuery<UserModel[]>({
    queryKey: ['admin-users'],
    queryFn: () => UserApiClient.getAdminUsers()
  });
}
